import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Smartphone } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try { await login(email, password); nav("/admin"); }
    catch (e2) { setErr(e2.response?.data?.detail || "Accesso non riuscito"); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#090B0E] px-4">
      <Seo title="Accedi · iPhix Scafati" noindex />
      <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#11141A] p-8">
        <Link to="/" className="mb-6 flex items-center justify-center gap-2">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#2563EB] text-white"><Smartphone className="h-5 w-5" /></span>
          <span className="font-display text-xl font-extrabold text-white">IPHIX Control Center</span>
        </Link>
        <p className="mb-6 text-center text-sm text-zinc-400">Accesso riservato allo staff</p>
        {err && <div className="mb-4 rounded-lg border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-sm text-rose-400">{err}</div>}
        <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="mb-3 w-full rounded-lg border border-white/10 bg-[#090B0E] px-3 py-2.5 text-sm text-white outline-none focus:border-[#2563EB]/50" />
        <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="mb-5 w-full rounded-lg border border-white/10 bg-[#090B0E] px-3 py-2.5 text-sm text-white outline-none focus:border-[#2563EB]/50" />
        <button data-testid="login-submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-full bg-[#2563EB] py-2.5 font-semibold text-white disabled:opacity-60"><Lock className="h-4 w-4" /> {loading ? "Accesso…" : "Accedi"}</button>
      </form>
    </div>
  );
}
